<script>
	import CheckinFilterModal from './CheckinFilterModal'
	import {Form} from '../../helpers/Form/Form'

	export default {
		props: {
			companyId: Number,
			userId: Number
		},
		components: {CheckinFilterModal},
		data() {
			return {
				checkin_counter: null,
				currentUserId: null,
				members: [],
				buyables: [],
				fetch: new Form({
					company_id: this.companyId,
					member_id: ''
				}),
				form: new Form({
					id: null,
					member_id: null,
					user_id: null,
					checkinable_id: null,
					checkinable_type: null,
					buyable_id: null,
					buyable_type: null,
					filters: {
						sport: null,
						age: null,
						day: null,
					},					
				}),
				ageRanges: [
					'0-5', '5-9', '10-19', '20-29', '30-39', '40-49', '50-59', '60-69', '70-79', '80-89', '90-99'
				],
				user: {},
				member: {},
				buyable: null,
				checkin: null,
				checkinable: null
			}
		},
		watch: {
			'form.buyable_id': {
				handler(val) {
					this.getCheckinCounter()
				}
			}
		},
		mounted() {
			this.getUser()
		},
		methods: {
			async getCheckinCounter() {
				this.form
					.submit('post', route('checkin.counter', this.companyId))
					.then(response => {
						this.$set(this, 'checkin_counter', response)
					})
			},
			async getUser(member = null, init = true) {
				this.members = []
				let response = await this.fetch.get(route('users.get', this.userId))

				this.$set(this, 'user', response.user)
				this.$set(this, 'member', response.member)
				this.$set(this, 'checkin', response.checkin)
				this.$set(this, 'checkinable', response.checkinable)
				this.$set(this, 'buyable', response.buyable)

				this.$set(this.form, 'user_id', this.userId)
				this.$set(this.form, 'member_id', this.member ? this.member.id : null)

				if (init) {
					this.initMemberSelect2()
					this.initActivitiesSelect2()
					this.initBuyablesSelect2()

					if (this.member) {
						this.members.push(this.member)

						let newOption = new Option(this.member.full_name, `member-${this.member.id}`, false, true);
						$(this.$refs.member).append(newOption).trigger('change');
					} else {
						this.members.push(this.user)

						let newOption = new Option(this.user.full_name, `user-${this.user.id}`, false, true);
						$(this.$refs.member).append(newOption).trigger('change');						
					}					
				} else {
                	this.$set(this.form, 'member_id', member.id)
                	if (member.user_id) {
                		this.$set(this.form, 'user_id', member.user_id)    	 
                	}      					
				}	

				if (this.buyable && this.buyable.hasOwnProperty('id')) {
					let newOption = null
					if (this.buyable.hasOwnProperty('reservation_name')) {
						newOption = new Option(this.buyable.reservation_name, `${this.buyable.class_name}-${this.buyable.id}`, true, true);
					} else {
						newOption = new Option(this.buyable.name, `${this.buyable.class_name}-${this.buyable.id}`, true, true);
					}

					$(this.$refs.buyables).append(newOption).trigger('change');						
				} else {
					$(this.$refs.buyables).val(null).trigger('change');
				}

				if (this.checkinable && this.checkinable.hasOwnProperty('id')) {
					let newOption = new Option(this.checkinable.name, `${this.checkinable.class_name}-${this.checkinable.id}`, true, true);
					$(this.$refs.activities).append(newOption).trigger('change');					
				} else {
					$(this.$refs.activities).val(null).trigger('change');
				}
			},
			initMemberSelect2() {
				let vm = this

	            $(this.$refs.member).select2({
	                ajax: {
	                    url: route('companies.members', this.companyId),
	                    delay: 500,
	                    data: function (params) {
	                        return {
	                    		q: params.term,
	                    		user_id: vm.userId
	                    	}
	                    },
	                    processResults: function (data) {
	                        var results = [];

	                        vm.$set(vm, 'members', data.members)
	                        data.members.forEach(function (a, b) {
	                            results.push({
	                                id: `member-${a.id}`,
	                                text: a.full_name
	                            })
	                        })
	                        return {
	                            results
	                        };
	                    }
	                }            	
	            }).on('change', function (event) {
	            	let selected = $(this).select2('data')[0];

                    if (_.isObject(selected)) {
                    	let splitIdData = selected.id.split('-')
                    	if (splitIdData[0] == 'member') {
	                    	let member = _.head(vm.members.filter(i => i.id == splitIdData[1]))

	                    	if (member) {
	                    		if (member.id != vm.form.member_id) {
	                    			vm.$set(vm.fetch, 'member_id', member.id)
	                    			vm.getUser(member, false)
	                    		} else {
			                    	vm.$set(vm.form, 'member_id', splitIdData[1])
			                    	if (member.user_id) {
				                		vm.$set(vm.form, 'user_id', member.user_id)    	 
				                	}          
				                }  
	    		            }
	    		        }
                    }
	            })	            
			},
			initActivitiesSelect2() {
				let vm = this

	            $(this.$refs.activities).select2({
	                ajax: {
	                    url: route('company.activities'),
	                    delay: 500,
	                    data: function (params) {
	                    	let query = {
	                    		company_id: vm.companyId,
	                    		name: params.term
	                    	}

	                    	for (let filter in vm.form.filters) {
	                    		if (vm.form.filters[filter]) {
		                    		query[filter] = vm.form.filters[filter]
		                    	}
	                    	}

	                        return query
	                    },
	                    processResults: function (data) {
	                        var results = [];

	                        data.courses.forEach(function (a, b) {
	                            results.push({
	                                id: `${a.class_name}-${a.id}`,
	                                text: a.name,
	                            })
	                        })

	                        data.events.forEach(function (a, b) {
	                            results.push({
	                                id: `${a.class_name}-${a.id}`,
	                                text: a.name
	                            })
	                        })

	                        return {
	                            results
	                        };
	                    }
	                }            	
	            }).on('change', function (event) {
	            	let selected = $(this).select2('data')[0];

                    if (_.isObject(selected)) {
                    	let splitData = selected.id.split('-')
                    	vm.$set(vm.form, 'checkinable_id', parseInt(splitData[1]))
                    	vm.$set(vm.form, 'checkinable_type', splitData[0])
                    }
	            })	            
			},	
			initBuyablesSelect2() {
				let vm = this

	            $(this.$refs.buyables).select2({
	                ajax: {
	                	dataType: 'json',
	                    url: function() {
	                    	return route('checkin.member_buyables', vm.form.member_id)
	                    },
	                    delay: 500,
	                    data: function (params) {
	                    	let query = {
	                    		checkinable_id: vm.form.checkinable_id,
	                    		checkinable_type: vm.form.checkinable_type,
	                    	}

	                        return query
	                    },
	                    processResults: function (data) {
	                        var results = [];

	                        data.subscriptions
	                        	.filter(i => i.can_be_selected)
	                        	.forEach(i => {
		                            results.push({
		                                id: `${i.product.buyable_type}-${i.product.buyable_id}`,
		                                text: i.product.name,
		                            })
	                        })

	                        data.reservations.filter(i => !i.is_expired).forEach(i => {
	                            results.push({
	                                id: `${i.class_name}-${i.id}`,
	                                text: i.reservation_name,
	                            })
	                        })	                        

	                        return {
	                            results
	                        };
	                    }
	                }            	
	            }).on('change', function (event) {
	            	let selected = $(this).select2('data')[0];

                    if (_.isObject(selected)) {
                    	let splitData = selected.id.split('-')
                    	vm.$set(vm.form, 'buyable_id', parseInt(splitData[1]))
                    	vm.$set(vm.form, 'buyable_type', splitData[0])
                    }
	            })	            
			},					
			updateFilters(payload) {
				this.$set(this.form.filters, payload.key, payload.value)
				$(".checkin-modal-filters").modal('hide')
			},
			onCheckIn() {
				let method = 'post'
				let action = route('checkin.store', this.companyId)
				if (this.checkin && this.checkin.hasOwnProperty('id')) {
					method = 'put'
					action = route('checkin.update', this.checkin.id)
				}

				this
					.form
					.submit(method, action)
					.then(response => {
						if (method == 'post') {
							location.href = route('checkin.summary', this.companyId)
						} else {
							location.href = route('checkout.summary', this.companyId)
						}
					})
					.catch(error => {
						window.toastr.error("Compila i campi segnati in rosso");
					})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/checkin/CheckinContainer.vue